import { SET_ACTIVE_APPOINTMENT } from "../../../../enums/AuthType";

export const setActiveAppointmentAction = (pid) => {
    return {
        type: SET_ACTIVE_APPOINTMENT,
        payload: pid,
    };
};